import { useAuth0 } from "@auth0/auth0-react";
import { useFormik } from "formik";
import PastoralService from "Lib/API/PastoralApi/index";
import { scheduleUpdateSchema } from "pages/ValidationSchema/scheduleUpdateSchema";
import React, { useState } from "react";
import { toastr } from "react-redux-toastr";
import AddNewReportFields from "./AddNewReportFields";
import AddNewReportHeader from "./AddNewReportHeader";
import "./index.scss";

function AddNewReport({ 
  type,
  closeModal,
  handleClose,
  eventTypes,
  eventTypesLoading, 
  openAddGroup,
  groupsList,
  groupLoading,
  frequencyList,
  frequencyLoading,
  fetchScheduleReports,
  scheduleData
 }) {
  const { getAccessTokenSilently } = useAuth0();

  const [isLoading, setIsLoading] = useState(false);



  const createScheduleHandler = async (input) => {
    setIsLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.createScheduleReports({ token, data:input })
      .then((res) => {
        if (res) {
          toastr.success("Success", "Scheduled update created successfully");
          fetchScheduleReports(1);
          handleClose();
        }
      })
      .catch((error) => {
        toastr.error("Error", error?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }
  const updateScheduleHandler = async (input) => {
    setIsLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.updateScheduleReports({ token, data:input, reportId: scheduleData?.id })
      .then((res) => {
        if (res) {
          toastr.success("Success", "Scheduled update updated successfully");
          fetchScheduleReports(1);
          handleClose();
        }
      })
      .catch((error) => {
        toastr.error("Error", error?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }



  const initialValues = {
    active: type === "edit" ? scheduleData?.active1 ? true : false : true,
    eventType:  type === "edit" ? eventTypes.find((item) => item?.value === scheduleData?.eventTypeID) || "" : "",
    group: type === "edit" ? groupsList.find((item) => item?.value === scheduleData?.groupID) || "" : "",
    frequency: type === "edit" ? frequencyList.find((item) => item?.value === scheduleData?.frequency) || "" : "",
    subject: type === "edit" ? scheduleData?.subject : "",
    from: type === "edit" ? scheduleData?.from1 : "",
    message: type === "edit" ? scheduleData?.text?.replace(/\\r\\n/g, "\n").replace(/\\n/g, "\n") : "{{list}}",
    comingSoon: scheduleData?.commingSoon ? true : false,
    followUp:  scheduleData?.followup ? true : false,
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: scheduleUpdateSchema,
    
    onSubmit: async (values) => {
      if (!checkValidation()) return;
      const input = {
        active1: values?.active,
        eventTypeID: values?.eventType?.value,
        groupID: values?.group?.value,
        frequency: values?.frequency?.value,
        subject: values?.subject,
        from1: values?.from,
        text: values?.message,
        commingSoon: values?.comingSoon,
        followup: values?.followUp,
      };
      if(type === "edit") {
        updateScheduleHandler(input);
      } else {
        createScheduleHandler(input);
      }
      
    },
  });

  const checkValidation = () => {
    if(!formik.values?.message?.includes("{{list}}")) {
      toastr.info("validation", "Text should contain {{list}} token");
      return false;
    }
    return true;
  }


  return (
    <div className="add-new-report">
      <AddNewReportHeader closeModal={closeModal} formik={formik} onSubmit={formik.handleSubmit} isLoading={isLoading}/>
      <AddNewReportFields 
        formik={formik}
        eventTypes={eventTypes}
        eventTypesLoading={eventTypesLoading}
        openAddGroup={openAddGroup}
        groupsList={groupsList}
        groupLoading={groupLoading}
        frequencyList={frequencyList}
        frequencyLoading={frequencyLoading}
      />
    </div>
  );
}

export default AddNewReport;
